import { TFunction } from 'next-i18next'
import { Route } from '../../config/router'

export const getLinkText = (backTo: Route, t: TFunction): string => {
  const key = backTo.slice(1).replace(/\//g, '-')
  return t(`common:page.${key}`, { context: 'back' })
}
